import { CssBaseline, ThemeProvider } from "@mui/material";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import "./output.css";
import "./index.scss";
import { ProvidersReactQuery } from "./providers-react-query";
import reportWebVitals from "./reportWebVitals";
import router from "./router";
import store from "./shared/redux/store";
import theme from "./styles/theme";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ProvidersReactQuery>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <RouterProvider router={router} />
        </ThemeProvider>
      </ProvidersReactQuery>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
